import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tutor-session-requests"
export default class extends Controller {
  updateStatus(event) {
    const status = event.target.value
    const id = event.target.id
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    const requestParams = {
      status: parseInt(status)
    };

    fetch('/tutors/live_session_requests/' + id, {
      method: 'PUT',
      headers: {
        'X-CSRF-Token': csrfToken,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({live_session_request: requestParams})
    })
      .then(response => response.json())
      .then(data => {
        if (data.status == "success"){
          window.location.reload();
        }
        //
      })
      .catch(error => {
        // Handle any errors
      });
  }
}
